'use strict';
/**
 * A service to handle navigation overlay. You can open or close the overlay, as well as set the callback to open and close.
 */

angular.module('youth').service('navSvc', ['$log', function ($log) {
  var isOpen = false;
  var callback = function callback() {
    $log.error('callback not set up');
  };

  function open() {
    isOpen = true;
    callback(isOpen);
  }

  function close() {
    isOpen = false;
    callback(isOpen);
  }

  function toggle() {
    isOpen = !isOpen;
    callback(isOpen);
  }

  function setCallback(back) {
    callback = back;
  }
  return {
    open: open,
    close: close,
    setCallback: setCallback,
    toggle: toggle
  };
}]);